import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { preloadMediaToken } from '@confluence/fabric-media-support/entry-points/preloadMediaToken.ts';
import { preloadSmartCreateEditorData } from '@confluence/smart-create-page-editor/entry-points/preloadSmartCreateEditorData.ts';

export const preloadSmartCreateEditorRoute = async (contentId: string): Promise<unknown> => {
	return waitForAllReturnWhenError([
		preloadSmartCreateEditorData(contentId),
		preloadMediaToken(contentId),
	]);
};
